<template>
  <v-dialog v-model="getModalExclusaoVenda" persistent max-width="720px">
    <v-card outlined>
      <v-card-title>Excluir Venda</v-card-title>
        <v-form class="px-3" ref="formExcluirVenda">
      <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md12>
              <v-text-field
                label="Motivo da exclusão"
                v-model="motivo_exclusao"
                placeholder="Descreva o motivo da exclusão."
                outlined
                dense
                class="ml-2 mr-2"
                :rules="rules.motivo_exclusao"
              ></v-text-field>
            </v-flex>
          </v-layout>
      </v-card-text>
        </v-form>
      <v-card-actions>
        <v-btn color="default" outlined @click="setModalExclusaoVenda(false)" :loading="$store.getters.getOverlay">Voltar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="error" outlined @click="_excluirVenda()" :loading="$store.getters.getOverlay">Excluir</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      motivo_exclusao: "",
      rules: {
        motivo_exclusao: [(v) => !!v || "Campo obrigatório."],
      },
    };
  },
  watch: {
    getModalExclusaoVenda(){
      if(this.getModalExclusaoVenda){
        this.motivo_exclusao = ""
      }
    }
  },
  computed: {
    ...mapGetters(["getModalExclusaoVenda", "getVenda"]),
  },
  methods: {
    ...mapActions(["setModalExclusaoVenda", "excluirVenda"]),
    _excluirVenda() {
      if (this.$refs.formExcluirVenda.validate()) {
        this.excluirVenda({
          ...this.getVenda,
          motivo_exclusao: this.motivo_exclusao,
        });
      }
    },
  },
};
</script>